'use client'

import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useUser } from '@/hooks/useUser'
import { useAutoLogout } from '@/hooks/useAutoLogout'
import AutoLogoutWarning from './AutoLogoutWarning'

interface AutoLogoutProviderProps {
  children: React.ReactNode
}

export default function AutoLogoutProvider({ children }: AutoLogoutProviderProps) {
  const { user, loading } = useUser()
  const location = useLocation()
  const pathname = location.pathname

  // Don't activate auto-logout on auth pages
  const isAuthPage = pathname === '/auth' || pathname === '/auth/reset-password'
  const shouldActivateAutoLogout = user && !loading && !isAuthPage

  const {
    showWarning,
    timeLeft,
    extendSession,
    formatTimeLeft
  } = useAutoLogout({
    timeout: 30, // 30 minutes
    warningTime: 5, // 5 minutes warning
    onWarning: () => {
        // setHasShownWarning(true)
      // Optional: Play a sound or show browser notification
      if ('Notification' in window && Notification.permission === 'granted') {
        new Notification('Session Timeout Warning', {
          body: 'Your session will expire in 5 minutes due to inactivity.',
          icon: '/logo.png'
        })
      }
    },
    onLogout: () => {
      // setHasShownWarning(false)
      // Optional: Show toast notification
      console.log('User logged out due to inactivity')
    }
  })

  // Request notification permission on mount
  useEffect(() => {
    if ('Notification' in window && Notification.permission === 'default') {
      Notification.requestPermission()
    }
  }, [])

  // Reset warning state when user changes or logs out
  useEffect(() => {
    if (!user) {
      // setHasShownWarning(false)
    }
  }, [user])

  // Don't render auto-logout for unauthenticated users or on auth pages
  if (!shouldActivateAutoLogout) {
    return <>{children}</>
  }

  const handleExtendSession = () => {
    extendSession()
      // setHasShownWarning(false)
  }

  return (
    <>
      {children}
      <AutoLogoutWarning
        isVisible={showWarning}
        timeLeft={timeLeft}
        onExtendSession={handleExtendSession}
        formatTimeLeft={formatTimeLeft}
      />
    </>
  )
}

